/* eslint-disable import/prefer-default-export */
// src/constants/store.ts

// key value used in localstorage
export const StoreKeys = {
    TOKEN: 'token',
    EXPIRE: 'expire',
  }
  